<template>
  <SrcBackground>

      <div class="w-full flex bg-skin-b-list-back divide-x md:border-x border-b border-skin-b-list-bord shadow lg:rounded-b-lg">
      <div @click="this.polling=false" class="inline-flex">
        <router-link to="/Main" custom v-slot="{ navigate }">
        <button type="button" @click="navigate" role="link"
        class="inline-flex items-center px-4 py-0 text-sm font-medium rounded-bl-lg
                                    text-skin-b-list-base bg-skin-b-list-back 
                                    hover:text-skin-b-base hover:bg-skin-b-list-head  
                                    focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base 
                                    transition duration-300 ease-in-out">
        <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="m13 18-8-8 8-8 1.417 1.417L7.833 10l6.584 6.583Z"></path>
        </svg>
        </button>
        </router-link>
      </div>

      <div class="inline-flex grow pl-6">
        <div class="my-auto pr-4 hidden sm:inline-block">
          <svg class="text-skin-b-list-mute" xmlns="http://www.w3.org/2000/svg" height="48" width="48" fill="currentColor">
            <path d="M11.3 40q-1.4 0-2.35-.95Q8 38.1 8 36.7q0-1.4.95-2.35.95-.95 2.35-.95 1.4 0 2.35.95.95.95.95 2.35 0 1.4-.95 2.35-.95.95-2.35.95ZM24 40q-1.4 0-2.35-.95-.95-.95-.95-2.35 0-1.4.95-2.35.95-.95 2.35-.95 1.4 0 2.35.95.95.95.95 2.35 0 1.4-.95 2.35Q25.4 40 24 40Zm12.7 0q-1.4 0-2.35-.95-.95-.95-.95-2.35 0-1.4.95-2.35.95-.95 2.35-.95 1.4 0 2.35.95.95.95.95 2.35 0 1.4-.95 2.35-.95.95-2.35.95ZM11.3 27.3q-1.4 0-2.35-.95Q8 25.4 8 24q0-1.4.95-2.35.95-.95 2.35-.95 1.4 0 2.35.95.95.95.95 2.35 0 1.4-.95 2.35-.95.95-2.35.95Zm12.7 0q-1.4 0-2.35-.95-.95-.95-.95-2.35 0-1.4.95-2.35.95-.95 2.35-.95 1.4 0 2.35.95.95.95.95 2.35 0 1.4-.95 2.35-.95.95-2.35.95Zm12.7 0q-1.4 0-2.35-.95-.95-.95-.95-2.35 0-1.4.95-2.35.95-.95 2.35-.95 1.4 0 2.35.95.95.95.95 2.35 0 1.4-.95 2.35-.95.95-2.35.95ZM11.3 14.6q-1.4 0-2.35-.95Q8 12.7 8 11.3q0-1.4.95-2.35Q9.9 8 11.3 8q1.4 0 2.35.95.95.95.95 2.35 0 1.4-.95 2.35-.95.95-2.35.95Zm12.7 0q-1.4 0-2.35-.95-.95-.95-.95-2.35 0-1.4.95-2.35Q22.6 8 24 8q1.4 0 2.35.95.95.95.95 2.35 0 1.4-.95 2.35-.95.95-2.35.95Zm12.7 0q-1.4 0-2.35-.95-.95-.95-.95-2.35 0-1.4.95-2.35Q35.3 8 36.7 8q1.4 0 2.35.95.95.95.95 2.35 0 1.4-.95 2.35-.95.95-2.35.95Z"/>
          </svg>        
        </div> 

        <div class="py-4">
          <h1 class="font-bold text-skin-b-list-base text-2xl">{{ $t('mesh.headline') }}</h1>
        <h4 class="font-medium text-skin-b-list-mute text-lg truncate">
          <span v-if="this.$store.state.WbClients?.length>0">{{ $t('mesh.wallbox', { count: this.$store.state.WbClients.length }, this.$store.state.WbClients.length ) }}</span>
          <span v-if="this.$store.state.wbgroups?.length>1"> &#8231; {{ $t('mesh.ingroup', { count: this.$store.state.wbgroups.length-1 }, this.$store.state.wbgroups.length-1 ) }}</span>
        </h4>
        </div>
      </div>

    </div>


    <loading-overlay :active="isLoading" :is-full-page="false" :width="128" :height="128" :loader="loader" :color="loadercolor" :background-color="loaderbackcolor" />

    <div class="px-4 mt-4">
        <div v-for="boxgroup in boxes.slice().reverse()" :key="boxgroup.name">
          <div :class="{ 'invisible': boxgroup.group.length==0 }" class="mt-4">
            <div class="p-4 bg-skin-b-list-head border border-skin-b-list-bord shadow rounded-t-lg">
              <h4 class="font-semibold text-xl text-skin-b-list-base leading-tight truncate">
                <svg class="inline-block w-7 h-7 -mt-1.5 text-skin-base" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.5 16q-.625 0-1.062-.438Q4 15.125 4 14.5t.438-1.062Q4.875 13 5.5 13t1.062.438Q7 13.875 7 14.5t-.438 1.062Q6.125 16 5.5 16Zm4.5 0q-.625 0-1.062-.438Q8.5 15.125 8.5 14.5t.438-1.062Q9.375 13 10 13t1.062.438q.438.437.438 1.062t-.438 1.062Q10.625 16 10 16Zm4.5 0q-.625 0-1.062-.438Q13 15.125 13 14.5t.438-1.062Q13.875 13 14.5 13t1.062.438Q16 13.875 16 14.5t-.438 1.062Q15.125 16 14.5 16Zm-9-4.5q-.625 0-1.062-.438Q4 10.625 4 10t.438-1.062Q4.875 8.5 5.5 8.5t1.062.438Q7 9.375 7 10t-.438 1.062q-.437.438-1.062.438Zm4.5 0q-.625 0-1.062-.438Q8.5 10.625 8.5 10t.438-1.062Q9.375 8.5 10 8.5t1.062.438q.438.437.438 1.062t-.438 1.062q-.437.438-1.062.438Zm4.5 0q-.625 0-1.062-.438Q13 10.625 13 10t.438-1.062Q13.875 8.5 14.5 8.5t1.062.438Q16 9.375 16 10t-.438 1.062q-.437.438-1.062.438ZM5.5 7q-.625 0-1.062-.438Q4 6.125 4 5.5t.438-1.062Q4.875 4 5.5 4t1.062.438Q7 4.875 7 5.5t-.438 1.062Q6.125 7 5.5 7ZM10 7q-.625 0-1.062-.438Q8.5 6.125 8.5 5.5t.438-1.062Q9.375 4 10 4t1.062.438q.438.437.438 1.062t-.438 1.062Q10.625 7 10 7Zm4.5 0q-.625 0-1.062-.438Q13 6.125 13 5.5t.438-1.062Q13.875 4 14.5 4t1.062.438Q16 4.875 16 5.5t-.438 1.062Q15.125 7 14.5 7Z"></path>
                </svg>             
                  {{ this.decodeHtml(boxgroup.name) }}<span v-if="boxgroup.info!=''"> &#8231; <small>{{ this.decodeHtml(boxgroup.info) }}</small></span>
              </h4>              
            </div>

            <div class="p-4 bg-skin-b-list-back border-x border-b border-skin-b-list-bord shadow rounded-b-lg">

          <draggable
            class="list-group grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 justify-items-center gap-4"
            :list="boxgroup.group"
            :disabled="!dragging"
            group="people"
            @change="log"
            itemKey="group"
          >
            <template #item="{ element }">
              <div :class="{ 'not-draggable': !dragging, 'yes-draggable': dragging }" 
                class="relative list-group-item inline-block w-full overflow-hidden font-semibold rounded text-skin-b-list-mute hover:text-skin-b-list-base">

                <ul v-if="element.id&&element.wallboxStatus!='no_connection'" @click="this.polling=false;this.$store.commit('setWbName', element.name);this.$store.commit('setWbId', element.id);this.$router.push({path: '/Main'})"
                  :class="element.id==this.$store.state.WbId ? 'border-skin-focus bg-skin-b-list-back hover:bg-skin-active128/10' : 'border-skin-b-list-bord hover:border-skin-focus bg-skin-b-list-back hover:bg-skin-active128/10'"
                  class="w-full rounded-t-lg border-b-2 cursor-pointer">
                  <li class="px-3 py-1 font-bold text-right text-skin-b-list-base text-xl truncate">
                    <span v-if="element.hostname==this.$store.state.WbLogHost" class="inline-flex mr-1">
                      <svg class="pt-1" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20">
                        <path d="M480 912v-72h264V312H480v-72h264q29.7 0 50.85 21.15Q816 282.3 816 312v528q0 29.7-21.15 50.85Q773.7 912 744 912H480Zm-72-168-51-51 81-81H144v-72h294l-81-81 51-51 168 168-168 168Z"/>
                      </svg>
                    </span>{{ this.decodeHtml(element.name) }}
                  </li>
                </ul>
                <ul v-if="element.id&&element.wallboxStatus=='no_connection'"
                  class="w-full rounded-t-lg border-b-2 cursor-default border-skin-b-list-bord bg-skin-b-list-back">
                  <li class="px-3 py-1 font-bold text-right text-skin-b-list-base text-xl truncate">
                      {{ $t('statusshort.error') }}
                  </li>
                </ul>

                <!--Gehäuse oberer Teil-->                
                <svg class="-mt-2" fill="currentColor" width="200" height="8" viewbox="0 0 200 8" xmlns="http://www.w3.org/2000/svg">
                    <path v-if="element.id"  :d="svgdata[0].wb_housingtop"></path>
                </svg>

                <svg class="" width="200" height="150" viewbox="0 0 200 150" xmlns="http://www.w3.org/2000/svg">
                  <!--Wallbox Inset-->
                  <g v-if="element.wallboxStatus=='unknown'||element.wallboxStatus=='booting'">
                   <rect fill="currentColor" fill-opacity=".125" height="40.865341" rx="3.338637" ry="3.36538" width="29.570795" x="25.214592" y="15.153822">
                   </rect>
                 </g>
                  <g v-if="element.wallboxStatus=='idle'">
                   <rect fill=rgb(34,197,94) fill-opacity=".5" height="40.865341" rx="3.338637" ry="3.36538" width="29.570795" x="25.214592" y="15.153822">
                   </rect>
                 </g>
                 <g v-if="element.wallboxStatus=='wait_unlock'||element.wallboxStatus=='connected'">
                   <rect fill=rgb(234,179,8) fill-opacity=".5" height="40.865341" rx="3.338637" ry="3.36538" width="29.570795" x="25.214592" y="15.153822">
                   </rect>
                 </g>
                 <g v-if="element.wallboxStatus=='auth_ok'">
                   <rect fill=rgb(255,255,255) fill-opacity=".5" height="40.865341" rx="3.338637" ry="3.36538" width="29.570795" x="25.214592" y="15.153822">
                   </rect>
                 </g>
                 <g v-if="element.wallboxStatus=='loading'||element.wallboxStatus=='loading_paused'">
                   <rect fill=rgb(59,130,246) fill-opacity=".5" height="40.865341" rx="3.338637" ry="3.36538" width="29.570795" x="25.214592" y="15.153822">
                   </rect>
                 </g>
                 <g v-if="element.wallboxStatus=='loading_planned'">
                   <rect fill=rgb(139,92,246) fill-opacity=".5" height="40.865341" rx="3.338637" ry="3.36538" width="29.570795" x="25.214592" y="15.153822">
                   </rect>
                 </g>
                 <g v-if="element.wallboxStatus=='loading_done'"><!--Grün rgb(34,197,94) -->
                   <rect fill=rgb(59,130,246) fill-opacity=".5" height="40.865341" rx="3.338637" ry="3.36538" width="29.570795" x="25.214592" y="15.153822">
                   </rect>
                 </g>
                 <g v-if="element.wallboxStatus=='error'||element.wallboxStatus=='no_connection'">
                   <rect fill=rgb(239,68,68) fill-opacity=".5" height="40.865341" rx="3.338637" ry="3.36538" width="29.570795" x="25.214592" y="15.153822">
                   </rect>
                 </g>
                  <!--LEDs-->
                  <g v-if="element.id">
                    <path 
                    fill="currentColor" 
                    :d="svgdata[2].wb_leds"/>
                  </g>
                  <!--RFID Logo-->
                  <g v-if="element.wallboxStatus=='wait_unlock'">
                    <path fill="currentColor" 
                    :d="svgdata[3].wb_rfidlogo"/>
                  </g>
                  <!--Gehäuse unterer Teil-->
                  <path v-if="element.id"
                    fill="currentColor"
                    :d="svgdata[1].wb_housing"/>
                    <!--Ladekabel am Auto angesteckt-->
                    <g v-if="element.wallboxStatus=='loading'||element.wallboxStatus=='loading_paused'||element.wallboxStatus=='wait_unlock'||element.wallboxStatus=='connected'||element.wallboxStatus=='loading_done'||element.wallboxStatus=='auth_ok'||element.wallboxStatus=='loading_planned'||element.wallboxStatus=='error'">
                        <path 
                          fill="currentColor"
                          :d="svgdata[4].cable_carconnect"/>
                    </g>
                    <!--Ladekabel an Box angesteckt-->
                    <g v-if="element.wallboxStatus=='idle'||element.wallboxStatus==''||element.wallboxStatus=='booting'">
                        <path 
                          fill="currentColor"
                          :d="svgdata[5].cable_wbconnect"/>
                    </g>
                   <!--Auto transparent-->
                   <g v-if="element.wallboxStatus=='idle'||element.wallboxStatus==''||element.wallboxStatus=='booting'">
                    <path
                    fill="currentColor"
                    fill-opacity=".125"
                    :d="svgdata[6].car_full"/>
                  </g>                   
                  <!--Auto ohne Batterie-->
                  <g v-if="element.wallboxStatus=='wait_unlock'||element.wallboxStatus=='connected'||element.wallboxStatus=='auth_ok'||element.wallboxStatus=='loading_planned'||element.wallboxStatus=='error'">
                    <path
                    fill="currentColor"
                    :d="svgdata[7].car_line"/>
                  </g>
                  <!--Auto mit Batterie-->
                  <g v-if="element.wallboxStatus=='loading'||element.wallboxStatus=='loading_paused'||element.wallboxStatus=='loading_done'">
                    <path
                    fill="currentColor"
                    :d="svgdata[8].car_linebattery"/>
                  </g>
                  <!--Ladebalken animiert-->
                  <g v-if="element.wallboxStatus=='loading'">
                    <rect transform="rotate(180,97,86.08316)" fill=rgb(59,130,246) width="17" height="37" x="80" y="49.08316">
                      <animate attributeName="height" from="0" to="37" dur="10s" begin="0s" repeatCount="indefinite"/>
                    </rect>
                  </g>
                  <!--Ladebalken Pausiert-->
                  <g v-if="element.wallboxStatus=='loading_paused'">
                   <rect transform="rotate(180,97,86.08316)" fill=rgb(59,130,246) width="17" height="37" x="80" y="49.08316">
                    <animate attributeName="opacity" values="0;1;0" dur="2s" repeatCount="indefinite"/>
                   </rect>
                 </g>                 
                 <!--Ladebalken Geladen-->
                 <g v-if="element.wallboxStatus=='loading_done'">
                   <rect transform="rotate(180,97,86.08316)" fill=rgb(59,130,246) width="17" height="37" x="80" y="49.08316">
                   </rect>
                 </g>
                </svg>

                <div class="absolute top-11 right-4 w-[12.25rem] ml-auto text-right font-semibold text-lg text-skin-b-list-mute">
                  <h4 v-if="element.wallboxStatus==''">
                    <span v-html="$t('statusshort.unknown')"></span>
                  </h4>
                  <h4 v-if="element.wallboxStatus=='idle'">
                    <span v-html="$t('statusshort.idle')"></span>
                  </h4>
                  <h4 v-if="element.wallboxStatus=='booting'">
                    <span v-html="$t('statusshort.booting')"></span>
                  </h4>
                  <h4 v-if="element.wallboxStatus=='auth_ok'" class="text-skin-b-list-base">
                    <span v-html="$t('statusshort.auth_ok')"></span>
                  </h4>
                  <h4 v-if="element.wallboxStatus=='pairing'">
                    <span v-html="$t('statusshort.pairing')"></span>
                  </h4>
                  <h4 v-if="element.wallboxStatus=='connected'">
                    <span v-html="$t('statusshort.connected')"></span>
                  </h4>
                  <h4 v-if="element.wallboxStatus=='loading'" class="text-skin-b-list-base">
                    <span v-html="$t('statusshort.loading')"></span>
                  </h4>
                  <h4 v-if="element.wallboxStatus=='loading_paused'" class="text-skin-b-list-base">
                    <span v-html="$t('statusshort.loading_paused')"></span>
                  </h4>
                  <h4 v-if="element.wallboxStatus=='loading_planned'" class="text-skin-b-list-base">
                    <span v-html="$t('statusshort.loading_planned')"></span>
                  </h4>
                  <h4 v-if="element.wallboxStatus=='loading_done'" class="text-skin-b-list-base">
                    <span v-html="$t('statusshort.loading_done')"></span>
                  </h4>
                  <h4 v-if="element.wallboxStatus=='error'" class="text-skin-b-list-base">
                    <span v-html="$t('statusshort.error')"></span>
                  </h4>
                  <h4 v-if="element.wallboxStatus=='no_connection'" class="text-skin-b-list-base">
                    <span v-html="$t('statusshort.no_connection')"></span>
                  </h4>
                </div>
                <div class="absolute top-[7rem] w-[13.5rem] text-left font-semibold text-normal leading-tight text-skin-b-list-mute">
                  <h6 v-if="element.wallboxStatus=='no_connection'" class="text-skin-b-list-base">
                    <span><small>{{ $t('mesh.hostname') }}: {{ element.hostname }}<br>{{ $t('mesh.serial') }}: {{ element.serial }}<br>{{ $t('mesh.ip') }}: {{ element.ip }}</small></span>
                  </h6>
                  <button type="button" 
                  v-if="element.wallboxStatus!='no_connection'&&element.SwInfo!=''"
                  @mouseover="SWtooltip=true" @mouseleave="SWtooltip=false"
                  :class="SWtooltip ? 'bg-skin-b-list-head border-skin-b-list-bord' : 'bg-transparent border-transparent'"
                  class="p-1 border-2
                          rounded font-semibold text-normal text-skin-b-list-base 
                          focus:bg-skin-b-list-head focus:outline-none focus:ring-0 
                          active:bg-skin-b-list-head">
                  <svg class="inline-block -mt-0.5 h-5 w-5" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                      <path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240ZM330-120 120-330v-300l210-210h300l210 210v300L630-120H330Zm34-80h232l164-164v-232L596-760H364L200-596v232l164 164Zm116-280Z"/>
                  </svg>                  
                  <span class="ml-2" v-if="SWtooltip">{{ element.SwInfo }}</span>
                </button>            
                </div>
              </div>
            </template>
            </draggable>
          </div>
          </div>
        </div> 
        </div>
        <div class="px-4 pt-12"></div>
  </SrcBackground>
</template>
<script>
import draggable from 'vuedraggable'
import SrcBackground from './sources/SrcBackground.vue'
import { useI18n } from 'vue-i18n'
export default {
  name: "SystemPage",
  components: {
    draggable, SrcBackground
  },
  setup () {
    const { t,d,n } = useI18n()
    return { t,d,n }
  },
  data() {
    return {
        polling: true,
        pollTimer: null,
        pollInFlight: false,
        checkSW: true,
        SWtooltip: false,
        pollmesh: [],
        svgdata: [
          {wb_housingtop:'m40 2c-6.6391 0-14.498228.0082969-15.986328.1542969-1.488.14587-2.604663.5780856-3.664063 1.3847656-1.0968.83516-2.297662 2.217115-2.976562 3.421875-.183688.3259747-.345767.6800343-.498047 1.0390625h46.324219c-.169624-.4363957-.360309-.8543302-.572266-1.2304688-.6789-1.2047699-1.879762-2.3953087-2.976562-3.2304687-1.0594-.80668-2.176063-1.2388956-3.664063-1.3847656-1.4881-.14588-9.347228-.1542969-15.986328-.1542969z'},
          {wb_housing:'m16.875 0c-.541357 1.2763508-.875 2.6889039-.875 3.7695312v54.2304688c0 1.61539.485147 3.307544 1.373047 4.115234 0 0 2.634028 2.346908 3.548828 2.923828.9147.576931 2.976259.544947 4.693359.691407 1.717.14646 4.883966.269531 14.384766.269531s12.667766-.123071 14.384766-.269531c1.7171-.14646 3.778659-.114476 4.693359-.691407.9148-.576919 3.548828-2.923828 3.548828-2.923828.8879-.80769 1.373047-2.499844 1.373047-4.115234v-54.2304688c0-1.033847-.300814-2.4832514-.800781-3.7695312zm14.9375.82421875c1.2022-.001 2.450469-.00096 3.667969 0 1.6233.001 3.191731.001953 4.519531.001953s2.896231-.00095313 4.519531-.001953c1.2175-.00096 2.465769-.001 3.667969 0 3.6066.004 6.795244.0219906 7.464844.0878906 1.1905.11669005 2.577081.41688685 3.425781 1.06054685.8525.6464501 1.302356 1.0680138 2.097656 2.3085938.7953 1.24057.886719 3.407945.886719 4.515625v47.806641c0 1.29231-.580616 2.646818-1.291016 3.292968 0 0-1.342418 1.300179-2.074218 1.761719s-.854916.628924-2.228516.746094c-1.3736.11716-8.86815.02344-16.46875.02344s-15.09515.09376-16.46875-.02344c-1.3736-.11717-1.496716-.284554-2.228516-.746094s-2.074218-1.761719-2.074218-1.761719c-.7104-.64615-1.291016-2.000658-1.291016-3.292968v-47.806641c0-1.10768.09152-3.275055.886719-4.515625.7953-1.24058 1.245156-1.6621438 2.097656-2.3085938.8487-.64366 2.235281-.9438568 3.425781-1.06054682.6696-.0656 3.858244-.0841906 7.464844-.0878906zm-3.259766 14.33007825c-1.8496 0-3.33789 1.500814-3.33789 3.365234v34.134766c0 1.86442 1.48829 3.365234 3.33789 3.365234h22.894532c1.8496 0 3.33789-1.500814 3.33789-3.365234v-34.134766c0-1.86442-1.48829-3.365234-3.33789-3.365234zm0 .480469h22.894532c1.5936 0 2.861328 1.278375 2.861328 2.884765v34.134766c0 1.6064-1.267728 2.884765-2.861328 2.884765h-22.894532c-1.5936 0-2.861328-1.278365-2.861328-2.884765v-34.134766c0-1.60639 1.267728-2.884765 2.861328-2.884765z'},
          {wb_leds:'m40 22.74988c-.6575 0-1.1935.53963-1.1935 1.20192 0 .6623.536 1.20193 1.1935 1.20193s1.1935-.53963 1.1935-1.20193c0-.66229-.536-1.20192-1.1935-1.20192zm-2.8431.26724c-.511.00001-.9283.4199-.9283.93468 0 .5148.4173.93487.9283.93488.5111.00001.9282-.42008.9282-.93488 0-.51479-.4171-.93469-.9282-.93468zm5.6862 0c-.5111-.00001-.9282.41989-.9282.93468 0 .5148.4171.93489.9282.93488.511-.00001.9283-.42008.9283-.93488 0-.51478-.4173-.93467-.9283-.93468zm-7.9988.26706c-.3645-.00001-.6631.30034-.6631.66762 0 .3673.2986.66783.6631.66782.3645 0 .6629-.30053.6629-.66782 0-.36727-.2984-.66762-.6629-.66762zm10.3114 0c-.3645 0-.6629.30035-.6629.66762 0 .36729.2984.66782.6629.66782.3645.00001.6631-.30052.6631-.66782 0-.36728-.2986-.66763-.6631-.66762z'},
          {wb_rfidlogo:'M 94.996094,15.290038 C 90.330866,19.955274 88,25.955942 88,31.954102 c 0,5.998162 2.330866,11.99492 6.996094,16.660156 l 2.667968,-2.664062 C 93.998526,41.951422 92,36.95257 92,31.954102 c 0,-4.998466 1.998526,-9.99732 5.664062,-13.996094 z m 50.007806,0 -2.66796,2.66797 C 146.00148,21.956782 148,26.955636 148,31.954102 c 0,4.998468 -1.99852,9.997318 -5.66406,13.996094 l 2.66796,2.664062 C 149.66914,43.949022 152,37.952264 152,31.954102 c 0,-5.99816 -2.33086,-11.998828 -6.9961,-16.664064 z m -44.67578,5.66797 c -2.999072,2.99908 -4.664058,6.997322 -4.664058,10.996094 0,3.998774 1.664986,7.997014 4.664058,10.996094 l 2.66797,-2.66797 c -2.33261,-2.332618 -3.332028,-5.329042 -3.332028,-8.328124 0,-2.99908 0.999418,-5.999414 3.332028,-8.332032 z m 39.34376,0 -2.66798,2.664062 c 2.33262,2.332618 3.33204,5.332952 3.33204,8.332032 0,2.079482 -0.5169,4.142942 -1.58984,6 v -0.722658 l -5.53126,-5.585936 v -5.3125 c 0,-1.893904 -1.53234,-3.445314 -3.41796,-3.445312 h -19.34766 c -1.88563,0 -3.41797,1.551408 -3.41797,3.445312 v 11.167968 c 0,1.893904 1.53234,3.44531 3.41797,3.445312 h 10.28906 L 132.2539,54.90332 h 12.01954 v -0.652344 -3.0625 L 138.7461,45.606444 V 42.02832 l 0.92578,0.921876 c 2.99908,-2.999084 4.66406,-6.99732 4.66406,-10.996094 0,-3.998772 -1.66498,-7.997014 -4.66406,-10.996094 z m -29.22266,3.234374 h 19.34766 c 1.17732,0 2.11328,0.941192 2.11328,2.140626 v 3.996094 7.171874 c 0,0.863196 -0.49316,1.577442 -1.20312,1.917968 -0.1164,0.04618 -0.22264,0.0749 -0.32814,0.10156 -0.1882,0.05436 -0.37504,0.11718 -0.58202,0.11718 h -1.36328 l -4.4961,-5.35547 -0.008,-0.0078 c -0.94206,-1.070044 -1.9247,-1.706184 -2.875,-1.957032 -0.95028,-0.250848 -1.87354,-0.09248 -2.55859,0.398438 -1.37014,0.981838 -1.62789,3.129898 -0.30079,5.144532 l 0.0196,0.02734 1.44532,1.75 h -9.21094 c -1.17732,0 -2.11328,-0.937286 -2.11328,-2.13672 V 26.333004 c 0,-1.199434 0.93596,-2.140626 2.11328,-2.140626 z m 22.76562,9.3125 4.22266,4.26172 v 8.375 l 5.52734,5.585936 v 1.871094 H 132.8711 L 119.27734,37.12207 c -1.05166,-1.610442 -0.71727,-2.843668 -0.0196,-3.34375 0.35034,-0.251044 0.83086,-0.36266 1.46484,-0.19532 0.63358,0.16724 1.41426,0.63257 2.22658,1.554688 l 4.875,5.808592 h 1.21092 0.76172 c 0,0 0.22024,-4.64e-4 0.54298,-0.05468 0.131,-0.02126 0.25722,-0.05396 0.3828,-0.08984 0.0888,-0.0233 0.1746,-0.05376 0.26954,-0.08594 0.0688,-0.02608 0.1366,-0.05168 0.20312,-0.08204 0.094,-0.03784 0.1856,-0.06104 0.28126,-0.10938 0.5755,-0.29061 1.14882,-0.86099 1.47266,-1.6875 0.0578,-0.14748 0.1058,-0.299514 0.1446,-0.464844 0.0734,-0.280224 0.121,-0.568444 0.121,-0.871094 z'},
          {cable_carconnect:'m38.5 66v40.99982c0 7.71422 6.2858 14 14 14s14-6.28578 14-14v-4.75195c0-.9722.4708-1.83762 1.1934-2.38672l.3066.51172c1.5-1.125 5.25-3.75 7.125-3.75h9.875c.554 0 1-.446 1-1v-5c0-.554-.446-1-1-1h-9.875c-3.75-.018-7.875 5.125-9.375 7l.3906.65234c-1.5937 1.0783-2.6406 2.90246-2.6406 4.97266v4.75195c0 6.0929-4.9071 11-11 11s-11-4.9071-11-11v-40.99982z'},
          {cable_wbconnect:'m64 47.00305c-.554 0-1 .446-1 1v5c0 .554.446 1 1 1h9.875c1.875 0 5.625 2.625 7.125 3.75l.3066-.51172c.7226.5491 1.1934 1.41452 1.1934 2.38672v26.75195h-.016c0 11.3396-9.1604 20.5-20.5 20.5s-20.5-9.1604-20.5-20.5h.016v-20.38h-3v20.38h-.016c0 12.96092 10.5391 23.5 23.5 23.5s23.5-10.53908 23.5-23.5h.016v-26.75195c0-2.0702-1.0469-3.89436-2.6406-4.97266l.3906-.65234c-1.5-1.875-5.625-7.018-9.375-7z'},
          {car_full:'m126.91666 67.00187c-8.93316.0353-24.90416.77704-37.260232 4.08008-1.225077.32751-2.183637 1.1126-3.273605 2.10352s-2.244641 2.22879-3.435716 3.5664c-2.382349 2.67524-4.912908 5.76014-6.998538 7.86328l-.035.0332-.031.0371c-1.462791 1.68073-1.499094 3.98231-1.648503 6.51757-.147509 2.50206-.16641 5.20687-.421926 7.21094-.934559 3.10036-2.157836 5.43439-1.720808 8.19727.0002.001-.0002.003 0 .004.878255 6.064 2.068229 9.33158 3.939647 11.23633 1.874317 1.90758 4.251866 1.9375 6.144985 1.9375h1.544997c2.050929 4.32112 6.333197 7.20457 11.188201 7.21094 4.857205-.004 9.140268-2.88788 11.192098-7.21094h54.71833c2.05073 4.32147 6.333 7.20457 11.1882 7.21094 4.85721-.004 9.14217-2.88784 11.194-7.21094h.85166c2.75357 0 5.90107.005 8.79155-.35547l.02-.002.02-.004c1.05747-.16034 2.59976-.37546 4.02566-.91992.71285-.27223 1.41629-.62393 2.01762-1.20508.60105-.58075 1.06947-1.48143 1.06257-2.45507.017-4.12063.052-9.14414-.34373-11.72266-1.01975-6.81654-4.30607-10.53846-8.1392-13.49219l-.082-.0625-.088-.0508c-2.15523-1.23148-5.29903-2.06117-8.79545-2.88476-3.49652-.8236-7.30946-1.5882-10.50456-2.41602l-.039-.01-.041-.008c-1.70731-.34392-3.1046-.70752-3.71514-1.3125l-.082-.082-.094-.0664c-15.24065-11.05792-21.61235-12.8365-25.85522-13.9707-4.21106-1.12574-6.3766-1.80286-15.30166-1.76758z'},
          {car_line:'m126.91666 67.00187c-8.93316.0353-24.90416.77704-37.260232 4.08008-1.225077.32751-2.183637 1.1126-3.273605 2.10352s-2.244641 2.22879-3.435716 3.5664c-2.382349 2.67524-4.912908 5.76014-6.998538 7.86328l-.035.0332-.031.0371c-1.462791 1.68073-1.499094 3.98231-1.648503 6.51757-.147509 2.50206-.16641 5.20687-.421926 7.21094-.934559 3.10036-2.157836 5.43439-1.720808 8.19727.0002.001-.0002.003 0 .004.878255 6.064 2.068229 9.33158 3.939647 11.23633 1.874317 1.90758 4.251866 1.9375 6.144985 1.9375h1.544997c2.050929 4.32112 6.333197 7.20457 11.188201 7.21094 4.857205-.004 9.140268-2.88788 11.192098-7.21094h54.71833c2.05073 4.32147 6.333 7.20457 11.1882 7.21094 4.85721-.004 9.14217-2.88784 11.194-7.21094h.85166c2.75357 0 5.90107.005 8.79155-.35547l.02-.002.02-.004c1.05747-.16034 2.59976-.37546 4.02566-.91992.71285-.27223 1.41629-.62393 2.01762-1.20508.60105-.58075 1.06947-1.48143 1.06257-2.45507.017-4.12063.052-9.14414-.34373-11.72266-1.01975-6.81654-4.30607-10.53846-8.1392-13.49219l-.082-.0625-.088-.0508c-2.15523-1.23148-5.29903-2.06117-8.79545-2.88476-3.49652-.8236-7.30946-1.5882-10.50456-2.41602l-.039-.01-.041-.008c-1.70731-.34392-3.1046-.70752-3.71514-1.3125l-.082-.082-.094-.0664c-15.24065-11.05792-21.61235-12.8365-25.85522-13.9707-4.21106-1.12574-6.3766-1.80286-15.30166-1.76758zm.012 2.99414c8.78396-.0347 10.24885.52516 14.51651 1.66602 4.23607 1.13239 9.82042 2.58016 24.87066 13.5l-.17381-.14844c1.5333 1.51953 3.55963 1.78601 5.23273 2.12305 3.30231.85217 7.08815 1.61151 10.48706 2.41211 3.38821.7981 6.4021 1.68997 7.9262 2.54297 3.51322 2.72304 6.00267 5.44471 6.90473 11.47461v.004.002c.29182 1.89998.32702 7.16338.31052 11.27929v.01.008c0 .12856.01.12624-.15031.28125-.16041.15501-.52263.37597-1.00596.56055-.96006.3666-2.32725.59162-3.38302.75195-2.61366.32455-5.65635.33203-8.40482.33203h-2.75798l-.35942.98047c-1.37298 3.74184-4.93061 6.22636-8.92826 6.23047-3.99675-.005-7.55187-2.48962-8.92446-6.23047l-.36132-.98047h-58.52907l-.36132.98047c-1.37269 3.74119-4.929512 6.22551-8.926362 6.23047-3.996751-.005-7.553774-2.48962-8.92636-6.23047l-.359323-.98047h-3.451416c-1.893119 0-2.958486.0292-4.010052-1.04101-1.051565-1.07024-2.271142-3.75821-3.113495-9.58789v-.01-.01c-.242715-1.52909.669042-3.60732 1.677905-7.01562l.033-.11328.016-.11524c.308219-2.33451.305419-5.1157.447328-7.52343.141808-2.40774.677742-4.45254.917957-4.72852l-.066.0723c2.258542-2.27749 4.7897-5.37504 7.109846-7.98047 1.160073-1.30272 2.265642-2.48044 3.213101-3.3418.94746-.86136 1.803813-1.36443 2.033328-1.42578 11.835643-3.16394 27.722633-3.94383 36.498383-3.97852z'},
          {car_linebattery:'m126.90933 67.00177c-8.9345.0357-24.8992.77792-37.252004 4.08008-1.2251.32751-2.1854 1.1126-3.2754 2.10352s-2.2444 2.22879-3.4355 3.5664c-2.3824 2.67524-4.9124 5.76014-6.9981 7.86328l-.035.0332-.031.0371c-1.4627 1.68073-1.499 3.98232-1.6484 6.51757-.1475 2.50208-.1664 5.20687-.4219 7.21094-.9345 3.10036-2.1577 5.43439-1.7207 8.19727.0002.001-.0002.003 0 .004.8783 6.064 2.068 9.33158 3.9394 11.23633 1.8743 1.90758 4.2534 1.9375 6.1465 1.9375h1.545c1.4021 2.95418 3.8467 5.23444 6.8046 6.38477-.3372-.76839-.5273-1.61236-.5273-2.49805v-1.03906c-1.8129-1.09298-3.2508-2.78217-4.0137-4.86133l-.3593-.98047h-3.4532c-1.8931 0-2.9581.0292-4.0097-1.04101-1.0516-1.07024-2.271-3.75821-3.1133-9.58789v-.01-.01c-.2427-1.52909.6688-3.60732 1.6777-7.01562l.033-.11328.016-.11524c.3082-2.33451.3054-5.1157.4473-7.52343.1413-2.39844.6725-4.4322.9141-4.72071 2.2434-2.2717 4.749-5.33334 7.0488-7.91601 1.1601-1.30272 2.2655-2.48044 3.2129-3.3418.9475-.86136 1.8036-1.36443 2.0332-1.42578 11.834804-3.16373 27.720004-3.94373 36.496104-3.97852 8.7821-.0346 10.2464.52525 14.5137 1.66602 4.236 1.13239 9.8209 2.58016 24.8711 13.5 1.5111 1.37855 3.4461 1.64979 5.0585 1.97461 3.3023.85217 7.0894 1.61151 10.4883 2.41211 3.3882.7981 6.4017 1.68997 7.9258 2.54297 3.5132 2.72304 6.0023 5.44471 6.9043 11.47461v.004.002c.2918 1.89998.3271 7.16338.3106 11.27929v.01.008c0 .12856.01.12624-.1504.28125s-.5226.37597-1.0059.56055c-.9601.3666-2.3271.59162-3.3828.75195-2.6137.32455-5.6558.33203-8.4043.33203h-2.7578l-.3594.98047c-1.373 3.74184-4.9321 6.22636-8.9297 6.23047-3.9968-.005-7.5512-2.48962-8.9238-6.23047l-.3613-.98047h-41.7272v2.99414h39.8203c2.0507 4.32147 6.3323 7.20457 11.1875 7.21094 4.8572-.004 9.1434-2.88784 11.1953-7.21094h.8516c2.7536 0 5.9005.005 8.791-.35547l.02-.002.021-.004c1.0574-.16034 2.5995-.37546 4.0254-.91992.7129-.27223 1.4162-.62393 2.0176-1.20508.601-.58075 1.0694-1.48143 1.0625-2.45507.017-4.12063.052-9.14414-.3438-11.72266-1.0198-6.81654-4.3055-10.53846-8.1386-13.49219l-.082-.0625-.09-.0508c-2.1553-1.23148-5.2984-2.06117-8.7949-2.88476-3.4965-.8236-7.3088-1.5882-10.5039-2.41602l-.039-.01-.041-.008c-1.7073-.34392-3.1043-.70752-3.7149-1.3125l-.082-.082-.094-.0664c-15.2406-11.05792-21.6126-12.8365-25.8555-13.9707-4.2098-1.12538-6.377-1.80239-15.2949-1.76758zm-26.4102 9.99805v5h-4.175804c-1.825 0-3.3242 1.49921-3.3242 3.32422v38.35156c0 1.82501 1.4997 3.32422 3.3496 3.32422h18.326204c1.825 0 3.3242-1.49962 3.3242-3.34961v-38.32617c0-1.82501-1.4992-3.32422-3.3242-3.32422h-4.1758v-5zm-3.500004 8h17.000004c.5523.00006.9999.44774 1 1v37c-.0001.55226-.4477.99994-1 1h-17.000004c-.5523-.00006-.9999-.44774-1-1v-37c.0001-.55226.4477-.99994 1-1z'}
        ],
        boxes : [],
        dragging: false,
        isLoading: false,
        loader: "spinner",
        loadercolor: 'rgb(var(--color-active-hsl-128))',
        loaderbackcolor: 'rgb(var(--color-b-back))',
    };
  },
  methods: {
    decodeHtml: function(html) {
    let txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
    },
    async pollData() {
      // One-time SW check
      if (this.checkSW) {
        try { await this.getSwVersions(); } catch (e) { console.log(e); }
        this.checkSW = false;
      }

      if (!this.polling) return;

      // prevent overlapping polls
      if (this.pollInFlight) return;
      this.pollInFlight = true;

      try {
        const token = this.$store.state.token;
        const url = `wallbox/client.php?action=reload_clients_async&user=${token}`;
        const response = await this.axios.get(url);

        if (response.data.status === 'token') {
          this.$router.push({ path: '/' });
          return;
        }

        if (response.data.status !== 'ok') {
          console.log('Error get Polldata');
          return;
        }

        const pollmesh = response.data.tbl_clients || [];

        // Build a fast lookup: clientId -> clientRef in boxes
        const clientRefById = new Map();
        this.boxes.forEach(box => {
          (box.group || []).forEach(client => {
            clientRefById.set(client.id, client);
          });
        });

        pollmesh.forEach(item => {
          const client = clientRefById.get(item.id);
          if (client) {
            client.wallboxStatus = item.wallboxStatus;
          }
          // if not found, ignore (prevents crashes)
        });

      } catch (err) {
        console.log(err);
      } finally {
        this.pollInFlight = false;

        // schedule next poll only if still enabled
        if (this.polling) {
          clearTimeout(this.pollTimer);
          this.pollTimer = setTimeout(() => this.execpoll(this.polling), 1000);
        }
      }
    },

    execpoll(polling) {
      if (!polling) return;
      this.pollData();
    },

    stopPolling() {
      this.polling = false;
      clearTimeout(this.pollTimer);
      this.pollTimer = null;
    },
    log: function(evt) {
      window.console.log(evt);
    },
  async getSwVersions() {
    const token = this.$store.state.token;
    const WbClients = this.$store.state.WbClients || [];
    const current = this.$store.state.WbSwVersion;

    const requests = WbClients.map(client => ({
      id: client.id,
      req: this.axios.get(`wallbox/info.php?action=get_version&user=${token}&client=${client.id}`)
    }));

    const results = await Promise.allSettled(requests.map(x => x.req));

    // Build lookup so we update by id, not by index
    const byId = new Map(WbClients.map(c => [c.id, c]));

    results.forEach((res, idx) => {
      const id = requests[idx].id;
      const client = byId.get(id);
      if (!client) return;

      const swOld = this.$t('mesh.swversionold');
      const swLabel = this.$t('mesh.swversion');

      if (res.status !== 'fulfilled') {
        client.SwInfo = swOld;
        return;
      }

      const data = res.value?.data;
      if (data?.status !== 'ok') {
        client.SwInfo = swOld;
        return;
      }

      const linuxVersion = data?.tbl_version?.linuxVersion ?? '';
      if (!linuxVersion) {
        client.SwInfo = swOld;
      } else if (linuxVersion !== current) {
        client.SwInfo = `${swLabel} ${linuxVersion}`;
      } else {
        client.SwInfo = '';
      }
    });
  },

  },
  beforeUnmount() {
    clearTimeout(this.pollTimer);
  },
  async created() {
    this.isLoading = true;
    this.boxes = []; // prevent accumulation

    try {
      const token = this.$store.state.token;
      const callGroupsUrl = `wallbox/client.php?action=get_groups&user=${token}`;
      const callMeshUrl   = `wallbox/client.php?action=get_clients&user=${token}`;

      const [groupsRes, meshRes] = await Promise.all([
        this.axios.get(callGroupsUrl),
        this.axios.get(callMeshUrl),
      ]);

      // Token invalid?
      if (groupsRes.data.status === 'token' || meshRes.data.status === 'token') {
        this.$router.push({ path: '/' });
        return;
      }

      if (!(groupsRes.data.status === 'ok' && meshRes.data.status === 'ok')) {
        console.log('Error get Groups and Clients');
        return;
      }

      // Normalize / decode
      const wbgroups = (groupsRes.data.tbl_groups || [])
        .sort((a, b) => a.id - b.id)
        .map(g => ({
          ...g,
          name: this.decodeHtml(g.name),
          info: this.decodeHtml(g.info),
        }));

      const WbClients = (meshRes.data.tbl_clients || [])
        .sort((a, b) => a.idx - b.idx)
        .map(c => ({
          ...c,
          name: this.decodeHtml(c.name),
          info: this.decodeHtml(c.info),
          SwInfo: '',
        }));

      // If you use Vuex properly, commit these instead of direct assignment:
      this.$store.state.wbgroups = wbgroups;
      this.$store.state.WbClients = WbClients;

      // Build group map
      const boxMap = new Map();
      wbgroups.forEach((g, idx) => {
        boxMap.set(g.id, {
          id: g.id,
          name: g.name,
          info: g.info,
          nr: idx + 1,
          group: [],
        });
      });

      // Assign clients to groups
      WbClients.forEach(client => {
        const box = boxMap.get(client.groupId);
        if (box) box.group.push(client);
      });

      // Keep only non-empty groups
      this.boxes = Array.from(boxMap.values()).filter(b => b.group.length !== 0);

      // Rename first group logic
      if (this.boxes.length === 1 && this.boxes[0].nr === 1) {
        this.boxes[0].name = '';
        this.boxes[0].info = '';
      } else if (this.boxes[0]?.nr === 1) {
        this.boxes[0].name = this.$t('mesh.noassignment');
        this.boxes[0].info = '';
      }

      this.pollData();
    } catch (err) {
      console.error(err);
    } finally {
      this.isLoading = false;
    }
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.not-draggable {
  cursor: default;
}
.yes-draggable {
  cursor: pointer;
}
</style>
